import { render, staticRenderFns } from "./TabelaLote.vue?vue&type=template&id=0bbf5c38&scoped=true&"
import script from "./TabelaLote.vue?vue&type=script&lang=js&"
export * from "./TabelaLote.vue?vue&type=script&lang=js&"
import style0 from "./TabelaLote.vue?vue&type=style&index=0&id=0bbf5c38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbf5c38",
  null
  
)

export default component.exports